import { render, staticRenderFns } from "./FreeSpeechWidget.vue?vue&type=template&id=7fdd071c&"
import script from "./FreeSpeechWidget.vue?vue&type=script&lang=js&"
export * from "./FreeSpeechWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports